/*
    name 公共固定值
    date 2022-12-13
*/
/*
    项目访问地址
*/
// const url = 'http://test.vmuyun.com/'; // 测试http
const url = 'https://vmuyun.com/'; // 线上https

// const url = 'http://192.168.0.7:60000/'// （任博）本地
// const url = 'http://192.168.0.14:60000/'// （张豪）本地

// const url = 'http://192.168.0.102:60000/'// 测试办公室
// const url = 'http://192.168.0.12:60000/'; // 平哥（本地）
// const url = 'http://192.168.0.36:60000/';
/*
    name 可视化智慧畜牧 颜色数组
*/
const imgUrl = 'http://test.vmuyun.com/'; // 测试地址，图片上传对比地址  等于测试active=test  不等于active=prod （打包不用管）
// const imgUrl = 'https://vmuyun.com/';
const mapColors = [
  '#FF72A6',
  '#3FA4FF',
  '#7547FF',
  '#65E2B6',
  '#FADB14',
  '#A0D911',
  '#1890FF',
  '#F5222D',
  '#D3ADF7',
  '#10239E',
  '#E2C465',
  '#FEFFE6'
];
/*
    name 畜值类型 （1羊，2猪，3牛，4驴）
*/
const livestockType = '3';

/*
    name  助贷需要字段内蒙和陕西
*/
const areaIds = '5, 27';
/*
    name 审批状态 （1羊，2猪，3牛，4驴）
*/
const approvalList = [
  {
    valueDesc: '补贴申请已提交',
    code: '0'
  },
  {
    valueDesc: '您的申请受理成功',
    code: '1'
  },
  {
    valueDesc: '您的申请被驳回,再次申请。',
    code: '2'
  },
  {
    valueDesc: '材料已提交',
    code: '3'
  },
  {
    valueDesc: '二次审核成功',
    code: '4'
  },
  {
    valueDesc: '二次审核失败',
    code: '5'
  },
  {
    valueDesc: '公示成功',
    code: '6'
  },
  {
    valueDesc: '公示失败',
    code: '7'
  },
  {
    valueDesc: '已补贴',
    code: '8'
  },
  {
    valueDesc: '可申请',
    code: '9'
  },
  {
    valueDesc: '300天内不可申请',
    code: '10'
  },
  {
    valueDesc: '无生产记录不可申请',
    code: '11'
  }
];

const livestockList = [
  {
    valueDesc: '空怀',
    code: 1
  },
  {
    valueDesc: '妊娠中',
    code: 2
  },
  {
    valueDesc: '死亡',
    code: 3
  },
  {
    valueDesc: '生产',
    code: 4
  }
];

// 配种状态 1:待配种 2：已配种 3：妊娠中 4：已生产
const matingList = [
  {
    name: '待配种',
    number: '1',
    type: true,
    activeArray: ['0']
  },
  {
    name: '已配种',
    number: '2',
    type: false,
    activeArray: ['3', '1']
  },
  {
    name: '公示中',
    number: '0',
    type: false,
    activeArray: ['5']
  }
];

const cowList = [
  {
    valueDesc: '母牛',
    code: 0
  },
  {
    valueDesc: '犊牛',
    code: 1
  }
];
const passwordKey = 'pigxpigxpigxpigx'; // 16位的加密串(加密密码)

module.exports = {
  mapColors,
  livestockType,
  areaIds,
  approvalList,
  livestockList,
  cowList,
  passwordKey,
  url,
  imgUrl
};



// WEBPACK FOOTER //
// ./src/utils/config.js